import React, { memo } from 'react';
import { View, Linking, Platform } from 'react-native';
import { useSelector } from 'react-redux';

import Logo from '../../Components/Logo';
import SocialNetwork from '../SocialNetwork';
import { getUIText } from '../../Helpers/translate';

import instagram from '../../Assets/Images/instagramIcon.png';
import facebook from '../../Assets/Images/facebookIcon.png';

import {
  Container,
  Text,
  Title,
  Subtitle,
  SmallSubtitle,
  ContainerSocialNetworks,
  SponsorContainer,
  FooterContainer,
  SectionContainer,
  CopyrightText
} from './styles';

const FooterHome = props => {
  const { store } = useSelector(state => state.general);
  const currentYear = new Date().getFullYear();

  const openUrl = url => {
    if (Platform.OS === 'web') {
      window.open(url);
    } else {
      Linking.openURL(url);
    }
  };

  return (
    <FooterContainer>
      <Container>
        {/* <Title>{getUIText('moreInfo', props.currentLanguage)}</Title> */}

        {store?.address && (
          <SectionContainer>
            <Subtitle>{getUIText('location', props.currentLanguage)}</Subtitle>
            <Text>{store?.address}</Text>
          </SectionContainer>
        )}

        {(store?.email || store?.website) && (
          <SectionContainer>
            <Subtitle>{getUIText('contacts', props.currentLanguage)}</Subtitle>
            {store?.email && <Text>{store?.email}</Text>}
            {store?.website && <Text>{store?.website}</Text>}
          </SectionContainer>
        )}

        {store?.openings?.length > 0 && (
          <SectionContainer>
            <Subtitle>{getUIText('hours', props.currentLanguage)}</Subtitle>
            {store.openings.map(item => (
              <View
                key={`${item.title} ${item.openTime}`}
                style={{ alignItems: 'center', marginBottom: 8 }}>
                <SmallSubtitle>{item.title}</SmallSubtitle>
                <Text>
                  {item.openTime} -{' '}
                  {item.lunchStartTime &&
                    item.lunchStartTime + '  / ' + item.lunchEndTime + ' - '}
                  {item.closeTime}
                </Text>
              </View>
            ))}
          </SectionContainer>
        )}

        {(store?.facebook || store?.instagram) && (
          <SectionContainer style={{ borderBottomWidth: 0 }}>
            <Subtitle>Redes Sociais</Subtitle>
            <ContainerSocialNetworks>
              {store?.facebook && (
                <SocialNetwork
                  type={'facebook'}
                  value={store?.facebook}
                  icon={facebook}
                />
              )}
              {store?.instagram && (
                <SocialNetwork
                  type={'instagram'}
                  value={store?.instagram}
                  icon={instagram}
                />
              )}
            </ContainerSocialNetworks>
          </SectionContainer>
        )}

        <CopyrightText>
          © {currentYear} {store?.name}. Todos os direitos reservados.
        </CopyrightText>

        <SponsorContainer
          activeOpacity={0.7}
          onPress={() =>
            openUrl(
              `https://menulegal.app?utm_source=${store?.name
              }&utm_medium=app_logo_footer&utm_campaign=client`,
            )
          }>
          <Text style={{ fontSize: 10, marginBottom: 5 }}>Powered by</Text>
          <Logo width="180" height="46" />
        </SponsorContainer>
      </Container>
    </FooterContainer>
  );
};

export default memo(FooterHome);
